import React, { useState } from "react";

/* =========================================================
   FULL PAGE BILLDESK REDIRECT
   ========================================================= */
const redirectToBillDesk = (redirect) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = redirect.url; // BillDesk URL

  const addHidden = (name, value) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  addHidden("bdorderid", redirect.params.bdorderid);
  addHidden("merchantid", redirect.params.mercid);
  addHidden("rdata", redirect.params.rdata);

  document.body.appendChild(form);
  form.submit();
};

/* =========================================================
   PAYMENT PAGE
   ========================================================= */
const TestPayment = () => {
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await fetch("/api/payment/create-order", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount }),
      });

      if (!res.ok) throw new Error("Order creation failed");

      const data = await res.json();
      redirectToBillDesk(data.billdesk_response.redirect);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: "40px auto" }}>
      <h2>BillDesk Payment</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="number"
          placeholder="Amount"
          required
          min="1"
          step="0.01"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />

        <button disabled={loading} style={{ marginTop: 10 }}>
          {loading ? "Redirecting..." : "Pay Now"}
        </button>
      </form>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default TestPayment;
